export default __webpack_public_path__ + "h12.png";